import React, { useState, useRef, useEffect } from "react";
import "./MenuPage.css";

// Title case for menu names, French style: small words (de, du, au, et...) stay lowercase.
const SMALL_WORDS = new Set(["de", "du", "des", "la", "le", "les", "au", "aux", "et", "en", "à", "un", "une", "sur", "par", "pour", "avec", "ou", "sans"]);
const fr = (text) => {
  if (typeof text !== "string") return text;
  return text
    .split(" ")
    .map((word, i) => {
      if (!word) return word;
      const lower = word.toLowerCase();
      if (i > 0 && SMALL_WORDS.has(lower)) return lower;
      if (i > 0 && /^[dl][’']/.test(lower)) return word; // d’orange, l’art ...
      return word
        .split("-")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join("-");
    })
    .join(" ");
};

const sections = [
  {
    id: "hot-drinks",
    title: "Boissons Chaudes",
    description: "Des boissons chaudes préparées avec soin pour vous réchauffer!",
    image: "/images/CafRoyal.webp",
    sectionImages: [
      "/images/CafRoyal.webp",
      "/images/Caffm.webp",
      "/images/Caf.webp"
    ],
    items: [
      { name: "Express", price: "2,5" },
      { name: "Capucin", price: "2,8" },
      { name: "Américain", price: "3" },
      { name: "Direct", price: "3,5" },
      { name: "Latte Vanille", price: "5" },
      { name: "Cappuccino", price: "5" },
      { name: "Café Turc", price: "5" },

      { 
        name: "Macchiato", 
        collapsibleItems: [
          { name: "Macchiato Chocolat/Dolce", price: "6" },
          { name: "Macchiato Noisette", price: "6" },
          { name: "Macchiato Caramel", price: "7" }
        ]
      },
      { name: "Supplément Nestlé", price: "1,5" },
      { name: "Supplément arôme", price: "1,5" },
      { name: "Verre de Lait", price: "1,5" },
      { name: "Shot café", price: "1,5" },
      { name: "Thé (infusion)", price: "2,5" },
      { name: "Chocolat au lait", price: "3,5" },
      { name: "Chocolat chaud", price: "5" },
    ]
  },
  {
    id: "cold-drinks",
    title: "Boissons Froides",
    description: "Des boissons fraîches et rafraîchissantes à savourer!",
    image: "/images/BlueIce.webp",
    sectionImages: [
      "/images/Frappucino.webp",
      "/images/MojitoBlue.webp",
      "/images/MojitoRed.webp"
    ],
    items: [
    { 
      subtitle: "Iced Coffee",
      items: [
      { name: "Iced Americano", price: "5 | 6" }, 
      { name: "Iced Latte", price: "6 | 8" },
      { name: "Iced Dolce", price: "7 | 9" },
  
      { 
        name: "Frappucino", 
        collapsibleItems: [
          { name: "Frappucino Chocolat/Café", price: "9 | 11" },
          { name: "Frappucino Noisette", price: "9 | 11" },
          { name: "Frappucino Caramel", price: "10 | 12" },
          { name: "Frappucino Nutella", price: "12 | 14" }
        ]
      },

      { 
        name: "Iced Macchiato", 
        collapsibleItems: [
          { name: "Iced Macchiato Chocolat", price: "8 | 10" },
          { name: "Iced Macchiato Noisette", price: "8 | 10" },
          { name: "Iced Macchiato Caramel", price: "9 | 11" }
        ]
      }

      ]
    },
    { name: "Supplément Nestlé", price: "1,5" },
    { name: "Supplément arôme", price: "1,5" },
    { 
      subtitle: "Boissons rafraîchissantes",
      items: [
      { name: "Citronnade", price: "4 | 5,5" },
      { name: "Jus de fraise", price: "5 | 7" },
      { name: "Panaché fraise-citron", price: "4,5 | 6" },
      { name: "Jus d’orange", price: "4,2 | 5,8" },

      { 
        name: "Mojito", 
        collapsibleItems: [
          { name: "Mojito Virgin", price: "8 | 9,5" },
          { name: "Mojito Red", price: "9 | 11" },
          { name: "Mojito Blue", price: "9 | 11" },
          { name: "Mojito Power", price: "13" }
        ]
      },
      
      { name: "Cocktail 2 Fruits", price: "7" },
      { name: "Cocktail 3 Fruits", price: "7,5" },
    ]
  },
  { 
    subtitle: "Iced Tea",
    items: [
      { name: "Thé vert glacé", price: "7,5" },
      { name: "Thé citron glacé", price: "7,5" },
      { name: "Thé fraise glacé", price: "7,5" },
    ]
  },
  { 
    subtitle: "Soft Drinks",
    items: [
      { name: "Soda", price: "3,5" },
      { name: "Redbull", price: "8" },
      
      { name: "Eau minérale 0,5L", price: "2" },
      { name: "Eau minérale 1L", price: "2,5" },
      { name: "Eau Garci 1L", price: "3" },
    ]
  },
    ]
  
  },  
  {
    id: "adaroza-tahricha",
    title: "Adaroza تحريـشة",
    description: "Offrez-vous une délicieuse pause gourmande à tout moment de la journée!",
    image: "/images/Gateau1.webp",
    sectionImages: [
      "/images/Gateau1.webp",
      "/images/Gateau2.webp", 
      "/images/Gateau3.webp"
    ],
    items: [
      {
        subtitle: "Khaffefi Bnin",
        items: [
          { name: "Croissant", price: "2,5" },
          { name: "Pain au chocolat", price: "2,5" },
          { name: "Cake Nature", price: "2,5" },
          { name: "Cake Chocolat", price: "3" },
          { name: "Amandine", price: "4" },
          { name: "Bahri", price: "2,7" }
        ]
      },
      {
        subtitle: "Miam Miam",
        items: [
          { name: "Gâteaux", price: "‘voir vitrine‘" }
        ]
      }
    ]
  },
  {
    id: "adaroza-gourmet",
    title: "Adaroza Gourmet",
    description: "Savourez notre sélection de délices gourmets faits maison.",
    image: "/images/crêpes 2.webp",
    sectionImages: [
      "/images/crêpes 2.webp",
      "/images/omelette.webp",
      "/images/Crêpe sucrée.webp"
    ],
    items: [
      {
        subtitle: "Crêpes Sucrées",
        items: [
          { name: "Chocolat", price: "9" },
          { name: "Chocolat banane", price: "12" },
          { name: "Nutella", price: "13" },
          { name: "Nutella banane", price: "16" },
          { name: "Supplément Fruit secs", price: "3" }
        ]
      },
      {
        subtitle: "Crêpes Salées",
        items: [
          { name: "Fromage", price: "8" },
          { name: "Thon", price: "8" },
          { name: "Jambon fromage", price: "10" },
          { name: "Thon fromage", price: "11" },
          { name: "Supplément œuf", price: "2" },
          { name: "Supplément jambon", price: "3" }
        ]
      },
      {
        subtitle: "Panini",
        items: [
          { name: "Panini jambon fromage", price: "6" },
          { name: "Panini thon fromage", price: "7" },
          { name: "Panini Oeuf fromage", price: "6,5" },
          { name: "Supplément jambon", price: "2" }
        ]
      },
      {
        subtitle: "Omelettes",
        items: [
          { name: "Omelette nature", price: "4,5" },
          { name: "Omelette fromage", price: "6,5" },
          { name: "Omelette thon", price: "7,5" },
          { name: "Omelette thon fromage", price: "9" }
        ]
      },
      {
        subtitle: "Oeuf au plat",
        items: [
          { name: "2 Oeufs", price: "4,5" },
          { name: "Supplément fromage", price: "2" },
          { name: "Supplément thon", price: "3" }
        ]
      }
    ]
  },  
  {
    "id": "breakfast",
    "title": "Petit-déjeuner",
    "description": "Commencez votre journée avec nos délicieux petits-déjeuners!",
    "image": "/images/New petit dej.webp",
    sectionImages: [
      "/images/New petit dej.webp",
      "/images/PetitDejClassique.webp"
    ],
    "items": [
      {
        "subtitle": "Adaroza",
        "items": [
          { "name": "Petit déjeuner 2 Personnes", "price": "35" },
          {
            "name": "par personne:",
            collapsibleItems: [
              { name: "Café" },
              { name: "Jus" },
              { name: "Viennoiserie" },
              { name: "Toast" },
              { name: "Chemeya" },
              { name: "Confiture" },
              { name: "Crêpe Chocolat" },
              { name: "Omelette" },
              { name: "Panini" },
              { name: "Eau 0,5L" }
            ]
          }
        ]
      },
      {
        "subtitle": "Formule Classique",
        "items": [
          { "name": "Petit déjeuner 1 Personne", "price": "11" },
          {
            "name": "Classique inclus:",
            collapsibleItems: [
              { name: "Café" },
              { name: "Jus" },
              { name: "Viennoiserie" },
              { name: "Toast" },
              { name: "Chemeya" },
              { name: "Confiture" },
              { name: "Eau 0,5L" }
            ]
          }
        ]
      },
      {
        "subtitle": "Light",
        "items": [
          { "name": "Petit déjeuner 1 Personne", "price": "8" },
          {
            "name": "Light inclus:",
            collapsibleItems: [
              { name: "Café" },
              { name: "Jus" },
              { name: "Viennoiserie" },
              { name: "Eau 0,5L" }
            ]
          }
        ]
      },
      {
        "subtitle": "Le sucré",
        "items": [
          { "name": "Petit déjeuner 1 Personne", "price": "16" },
          {
            "name": "Sucré inclus:",
            collapsibleItems: [
              { name: "Café" },
              { name: "Jus" },
              { name: "Viennoiserie" },
              { name: "Toast" },
              { name: "Chemeya" },
              { name: "Confiture" },
              { name: "Crêpe Chocolat" },
              { name: "Eau 0,5L" }
            ]
          }
        ]
      },
      {
        "subtitle": "Le salé",
        "items": [
          { "name": "Petit déjeuner 1 Personne", "price": "16" },
          {
            "name": "Salé inclus:",
            collapsibleItems: [
              { name: "Café" },
              { name: "Jus" },
              { name: "Toast" },
              { name: "Chemeya" },
              { name: "Confiture" },
              { name: "Omelette" },
              { name: "Panini" },              
              { name: "Eau 0,5L" }
            ]
          }
        ]
      },
      {
        subtitle: "Matiroza (avant 9h)",
        items: [
          { name: '1 café + 1 Khaffefi' },
          { name: "Formule Express +", price: "4" },
          { name: "Formule Capucin +", price: "5" },
          { name: "Formule Américain +", price: "4,5" },
          { name: "Formule Direct +", price: "5" }
        ]
      }
    ]
  },
  {
    id: "traditional-delights",
    title: "Spécialités Traditionnelles",
    description: "Des saveurs authentiques et des douceurs faites maison!",
    image: "/images/Assida.webp",
    sectionImages: [
      "/images/Dro3.webp",
      "/images/Assida.webp",
      "/images/Assida2.webp"
    ],
    items: [
      { name: "Assida Zgougou", price: "7" },
      { name: "Assida Noisette", price: "7,5" },
      {
        name: "Dro3 nature (درع)",
        price: "3,5",
        collapsibleItems: [
          { name: "Supplément Chemia", price: "1,5" },
          { name: "Supplément Fekia", price: "2,5" }
        ]
      },
    ]
  },
  {
    id: "pizza",
    title: "Pizza Tranche",
    description: "Nos pizzas à la tranche, au plateau ou en plateau complet!",
    image: "/images/PizzaTranche.webp",
    sectionImages: [
      "/images/PizzaTranche.webp"
    ],
    items: [
      {
        subtitle: "Pizza tranche",
        items: [
          {
            name: "Prix par format",
            description: "1/16 plateau | 1/8 plateau | 1/4 plateau | 1/2 plateau | Plateau complet"
          },
          { name: "Pizza Margherita", price: "5 | 8 | 16 | 32 | 64", description: "Sauce tomate, mozzarella, origan" },
          { name: "Pizza Thon", price: "6 | 11 | 22 | 42 | 80", description: "Sauce tomate, mozzarella, thon, olives, tomates, persil" },
          { name: "Pizza Pepperoni", price: "6 | 11 | 22 | 42 | 80", description: "Sauce tomate, mozzarella, pepperoni" },
          { name: "Pizza Jambon-fumé", price: "6 | 11 | 22 | 42 | 80", description: "Sauce tomate, sauce blanche, mozzarella, gruyère, jambon fumé" },
          { name: "Pizza Végétarienne", price: "6 | 11 | 22 | 42 | 80", description: "Sauce tomate, mozzarella, légumes de saison, sauce pesto" },
          { name: "Pizza poulet-pesto", price: "7 | 12 | 24 | 45 | 85", description: "Sauce blanche, mozzarella, escalope poulet, sauce pesto" }
        ]
      }
    ]
  },
{
  id: "Salades",
  title: "Salades",
  description: "Des salades fraîches et savoureuses, préparées avec des ingrédients sélectionnés.",
  image: "/images/Salade.webp",
  sectionImages: [
    "/images/Salade.webp"
  ],

  items: [
    {
      name: "Salade César",
      price: "13",
      description: "Laitue, tomates, poulet, fromage, croûtons, sauce, maïs"
    },

    {
      subtitle: "Salade à la carte",
      items: [
        {
          name: "Base salade verte",
          price: "6",
          description: "Laitue, tomates, concombre, sauce, toast"
        },
        {
          name: "Garniture au choix",
          collapsibleItems: [
            { name: "Jambon", price: "3" },
            { name: "Poulet ou Thon", price: "5" }
          ]
        },
        {
          name: "Suppléments",
          collapsibleItems: [
            { name: "Fromage", price: "3" },
            { name: "Maïs", price: "2" }
          ]
        }
      ]
    }
  ]
}
];

const SectionIcons = ({ sections, activeSection, onSectionClick }) => {
  const scrollContainerRef = useRef(null);

  const centerSelectedIcon = (sectionId) => {
    if (!scrollContainerRef.current) return;

    const selectedIcon = scrollContainerRef.current.querySelector(`.section-icon[data-section-id="${sectionId}"]`);

    if (selectedIcon) {
      const containerWidth = scrollContainerRef.current.offsetWidth;
      const iconWidth = selectedIcon.offsetWidth;
      const iconLeft = selectedIcon.offsetLeft;

      const scrollPosition = iconLeft - (containerWidth / 2) + (iconWidth / 2);

      scrollContainerRef.current.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    if (activeSection) {
      centerSelectedIcon(activeSection);
    }
  }, [activeSection]);

  return (
    <div className="section-icons" ref={scrollContainerRef}>
      {sections.map((section) => (
        <div
          key={section.id}
          className={`section-icon ${activeSection === section.id ? "active" : ""}`}
          onClick={() => onSectionClick(section.id)}
          data-section-id={section.id}
        >
          <img src={section.image} loading="lazy" alt={section.title} className="section-icon-image" />
        </div>
      ))}
    </div>
  );
};

const MenuPage = () => {
  const [activeSection, setActiveSection] = useState(null);
  const [height, setHeight] = useState(0);
  const [fadeIn, setFadeIn] = useState(false);
  const [showSections, setShowSections] = useState(true);
  const [openItems, setOpenItems] = useState({});
  const contentRef = useRef(null);
  const [menuData, setMenuData] = useState([]); // ✅ Updated menu with correct prices

  useEffect(() => {
    setMenuData(sections); // just use your static data
    if (contentRef.current) {
      setHeight(activeSection ? contentRef.current.scrollHeight : 0);
      setTimeout(() => setFadeIn(true), 100);
    }
  }, [activeSection]);
  

  // Keep the box height in sync with its real content height (fonts, images,
  // wrapping or opened items can change it after the first measurement).
  useEffect(() => {
    const el = contentRef.current;
    if (!el || !activeSection) return undefined;
    const update = () => setHeight(el.scrollHeight);
    update();
    if (typeof ResizeObserver === "undefined") {
      const timer = setInterval(update, 300);
      return () => clearInterval(timer);
    }
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [activeSection, menuData]);

  const handleSectionClick = (sectionId) => {
    if (activeSection === sectionId) {
      setFadeIn(false);
      setTimeout(() => {
        setActiveSection(null);
        setHeight(0);
        setShowSections(true);
      }, 300);
    } else {
      setFadeIn(false);
      setTimeout(() => {
        setActiveSection(sectionId);
        setFadeIn(true);
        setShowSections(false);
      }, 300);
    }
  };

  const toggleItem = (itemName) => {
    setOpenItems((prevOpenItems) => ({
      ...prevOpenItems,
      [itemName]: !prevOpenItems[itemName],
    }));

    setTimeout(() => {
      if (contentRef.current) {
        setHeight(contentRef.current.scrollHeight);
      }
    }, 100);
  };

  const activeMenu = menuData.find((s) => s.id === activeSection); // ✅ Use menuData instead of sections

  return (
    <div
      className="menu-container"
      style={{
        backgroundImage: "url('/images/home-bg.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      <h2 className="menu-title">Our Menu</h2>

      {!showSections && (
        <SectionIcons
          sections={menuData} // ✅ Use menuData instead of sections
          activeSection={activeSection}
          onSectionClick={handleSectionClick}
        />
      )}

      {showSections ? (
        <div key="menu-grid" className="menu-grid">
          {menuData.map((section) => ( // ✅ Use menuData
            <div
              key={section.id}
              className={`menu-card ${activeSection === section.id ? "active" : ""}`} // ✅ Fixed className syntax
              onClick={() => handleSectionClick(section.id)}
            >
              <img src={section.image} loading="lazy" alt={section.title} className="menu-card-image" />
              <h3 className="section-title">{fr(section.title)}</h3>
              <p className="section-description">{section.description}</p>
            </div>
          ))}
        </div>
      ) : (
        <div
          key="menu-details"
          className="menu-details-container"
          style={{
            height: `${height}px`,
            opacity: activeSection ? 1 : 0,
            transition: "height 0.3s ease-in-out, opacity 0.3s ease-in-out",
          }}
        >
          <div className={`menu-details ${fadeIn ? "fade-in" : ""}`} ref={contentRef}>
            {activeMenu && (
              <>
                <h3 className="menu-details-title">{fr(activeMenu.title)}</h3>
                <p className="menu-details-description">{activeMenu.description}</p>

                {activeMenu.sectionImages && activeMenu.sectionImages.length > 0 && (
                  <div className="menu-section-images">
                    {activeMenu.sectionImages.map((image, index) => (
                      <img key={index} src={image} alt={`Dish from ${activeMenu.title}`} className="menu-greenbox-image" />
                    ))}
                  </div>
                )}

                {activeMenu?.items && Array.isArray(activeMenu.items) && activeMenu.items.length > 0 ? (
                  <div
  className={`menu-list ${
    ["Salades", "pizza"].includes(activeMenu.id) ? "salades-list" : ""
  }`}
>
                    {activeMenu.items.map((item, index) => (
                      <div key={index} className="menu-item">
                        {item.collapsibleItems ? (
                          <>
                            <button
  className={`collapsible ${openItems[item.name] ? "active" : ""} ${["par personne:", "Classique inclus:", "Light inclus:", "Sucré inclus:", "Salé inclus:"].includes(item.name) ? "italic-title" : ""}`}
  onClick={() => toggleItem(item.name)}
>
  <span>{fr(item.name)}</span>
  <span className="menu-price">{item.price}</span>
</button>
                            <div className="content" style={{ display: openItems[item.name] ? "block" : "none" }}>
                              {item.collapsibleItems.map((subitem, subIdx) => (
                                <div key={subIdx} className="menu-item">
                                  <span className="menu-item-title">{fr(subitem.name)}</span>
                                  <span className="menu-price">{subitem.price}</span>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : item.items ? (
                          <>
                            <h4 className="menu-subtitle">{fr(item.subtitle)}</h4>
                            {item.items.map((subitem, subIdx) => (
                              <div key={subIdx} className="menu-item">
                                {subitem.collapsibleItems ? (
                                  <>
                                    <button
  className={`collapsible ${openItems[subitem.name] ? "active" : ""} ${["par personne:", "inclus:", "Classique inclus:", "Light inclus:", "Sucré inclus:", "Salé inclus:"].includes(subitem.name) ? "italic-title" : ""}`}
  onClick={() => toggleItem(subitem.name)}
>
  <span>{fr(subitem.name)}</span>
  <span className="menu-price">{subitem.price}</span>
</button>
                                    <div className="content" style={{ display: openItems[subitem.name] ? "block" : "none" }}>
                                      {subitem.collapsibleItems.map((nestedItem, nestedIdx) => (
                                        <div key={nestedIdx} className="menu-item">
                                          <span className="menu-item-title">{fr(nestedItem.name)}</span>
                                          <span className="menu-price">{nestedItem.price}</span>
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                ) : subitem.subitems ? (
                                  <>
                                    <span className="menu-item-title">{fr(subitem.name)}</span>
                                    <ul className="menu-subitems">
                                      {subitem.subitems.map((subsubitem, subsubIdx) => (
                                        <li key={subsubIdx}>{subsubitem}</li>
                                      ))}
                                    </ul>
                                  </>
                                ) : (
  <div className="menu-item-info">
    <div className="menu-item-header">
      <span className="menu-item-title">{fr(subitem.name)}</span>
      <span className="menu-price">{subitem.price}</span>
    </div>

    {subitem.description && (
      <p className="menu-item-description">
        {subitem.description}
      </p>
    )}
  </div>
                                )}
                              </div>
                            ))}
                          </>
                        ) : (
                            <div className="menu-item-info">
    <div className="menu-item-header">
      <span className="menu-item-title">{fr(item.name)}</span>
      <span className="menu-price">{item.price}</span>
    </div>

    {item.description && (
      <p className="menu-item-description">
        {item.description}
      </p>
    )}
  </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>No items available.</p>
                )}
              </>
            )}
          </div>
        </div>
      )}

      <section className="contact">
        <img src="/images/Logo Adaroza A.webp" alt="Adaroza Logo" />
        <p><b>Adresse:</b> Rue Ghar El Mehl 7, Lac 1</p>
        <p><b>Horaires:</b></p>
        <p>Lundi – Vendredi, 6:30 → 20:00</p>
        <p>Samedi – Dimanche, 8:00 → 20:00</p>
        <div className="social-media">
          <a href="https://www.facebook.com/profile.php?id=61565563451949" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="/images/facebook-icon.webp" alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/adaroza_cafe?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="/images/Insta-icon.webp" alt="Instagram" />
          </a>
          <a href="https://www.tiktok.com/@adaroza_cafe" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="/images/tiktok icon.webp" alt="Tiktok" />
          </a>
        </div>
      </section>
    </div>
  );
};

export default MenuPage;
